import { useContext } from 'react';

import { Flex, Table } from 'antd';

import { useDeleteCreatorFromCollection } from '@/api/monitor_collections';
import CollectionsMultiButton from '@/components/common/CollectionsMultiButton';
import { CollectionContext } from '@/providers/CollectionsContextProvider';
import { ICreatorsCollectionItem } from '@/ts';

type TProps = {
	data: any;
	columns: any;
	onTableChange: any;
	isLoading: boolean;
	isFetching?: boolean;
	pagination: any;
	setPagination: any;
	onEditCreatorClick: any;
};

export default function SingleCollectionCreatorsTable({
	data,
	columns,
	onTableChange,
	isLoading,
	pagination,
	setPagination,
	onEditCreatorClick,
}: TProps) {
	const { data: collectionStoreData } = useContext(CollectionContext);

	const { mutate: deleteCreator, isLoading: isDeleteLoading } =
		useDeleteCreatorFromCollection(collectionStoreData?.id);

	return (
		<Table
			size="small"
			dataSource={data}
			columns={[
				...columns,
				{
					title: 'Actions',
					// ellipsis: true,
					width: 65,
					dataIndex: 'actions',
					key: 'actions',
					fixed: 'right',
					render: (_: any, record: ICreatorsCollectionItem) => {
						return (
							<Flex justify="center" align="center" style={{ gap: '4px' }}>
								<CollectionsMultiButton
									record={record}
									type="creators"
									isSingleCreatorsCollection
									onEditClick={() => {
										onEditCreatorClick(record);
									}}
								/>
								{/* <EditButton
                  id={record.id}
                  onClick={() => {
                    console.log("record", record);

                    onEditCreatorClick(record);
                  }}
                />
                <Popconfirm
                  title={`Sure to remove creator?`}
                  onConfirm={() =>
                    onDeleteClick(record?.user_creators_collection_item_id)
                  }
                >
                  <Tooltip title="Remove">
                    <DeleteVideoButton
                      onClick={() => {}}
                      title="Remove from collection"
                    />
                  </Tooltip>
                </Popconfirm> */}
							</Flex>
						);
					},
				},
			]}
			style={{ width: '100%' }}
			// scroll={{ x: 500 }}
			rowClassName="editable-row"
			rowKey={'user_creators_collection_item_id'}
			onChange={onTableChange}
			loading={isLoading || isDeleteLoading}
			bordered
			pagination={{
				total: pagination?.total || 1,
				showSizeChanger: true,
				current: pagination?.page,
				pageSizeOptions: [10, 25, 50],
				onChange: (page: number, pageSize: number) => {
					setPagination((cur: any) => ({ ...cur, page, limit: pageSize }));
				},
			}}
		/>
	);
}
